import { useEffect, useState } from "react";
import ReactSpeedometer, { CustomSegmentLabelPosition } from "react-d3-speedometer";
import { ambienteInternoPontoForteService } from "../services/AmbienteInternoPontoForteService";
import { ambienteInternoPontoFracoService } from "../services/AmbienteInternoPontoFracoService";
import { ambienteExternoService } from "../services/AmbienteExternoService";
import { AMEACA, OPORTUNIDADE } from "../types/constants/ClassificacaoAmbienteExterno";
import { normalize } from "../utils/string";
import { AmbienteExterno } from "../types/negocio/AmbienteExterno";
import { AmbienteInternoPontoForte } from "../types/negocio/AmbienteInternoPontoForte";
import { AmbienteInternoPontoFraco } from "../types/negocio/AmbienteInternoPontoFraco";
const segmentLabelFontSize = "16px";

function calcularIndiceFavorabilidade(
    pontosFortesPontuacaoTotal: number,
    pontosFracosPontuacaoTotal: number,
    oportunidadesPontuacaoTotal: number,
    ameacasPontuacaoTotal: number
): number {
    const soma = pontosFortesPontuacaoTotal + pontosFracosPontuacaoTotal + oportunidadesPontuacaoTotal + ameacasPontuacaoTotal;
    if (soma === 0) return 0;
    // ((Forças + Oportunidades) / soma * 2) - ((Fraquezas + Ameaças) / soma * 2)
    const positivo = (pontosFortesPontuacaoTotal + oportunidadesPontuacaoTotal) / soma * 2;
    const negativo = (pontosFracosPontuacaoTotal + ameacasPontuacaoTotal) / soma * 2;
    return (positivo - negativo) * 100; // multiplica por 100 para escalar como percentual
}

export default function IndiceFavorabilidade() {

    const [indiceFavorabilidade, setIndiceFavorabilidade] = useState(0);

    useEffect(() => {
        var promises = [];
        let pontosFortes: AmbienteInternoPontoForte[] = [];
        let pontosFracos: AmbienteInternoPontoFraco[] = [];
        let oportunidades: AmbienteExterno[] = [];
        let ameacas:AmbienteExterno[] = [];
        promises.push(ambienteInternoPontoForteService.listarTodos().then((response) => pontosFortes = response));
        promises.push(ambienteInternoPontoFracoService.listarTodos().then((response) => pontosFracos = response));
        promises.push(ambienteExternoService.listarTodos().then((response) => {
            oportunidades = response.filter((item) => normalize(item.fator) === OPORTUNIDADE);
            ameacas = response.filter((item) => normalize(item.fator) === AMEACA);
        }));
        Promise.all(promises).then(() => {
            const pontosFortesPontuacaoTotal = pontosFortes.reduce((acc, e) => acc + e.pontuacao, 0);
            const pontosFracosPontuacaoTotal = pontosFracos.reduce((acc, e) => acc + e.pontuacao, 0);
            const oportunidadesPontuacaoTotal = oportunidades.reduce((acc, e) => acc + e.pontuacao, 0);
            const ameacasPontuacaoTotal = ameacas.reduce((acc, e) => acc + e.pontuacao, 0);

            const indice = calcularIndiceFavorabilidade(
                pontosFortesPontuacaoTotal,
                pontosFracosPontuacaoTotal,
                oportunidadesPontuacaoTotal,
                ameacasPontuacaoTotal
            );
            setIndiceFavorabilidade(indice);

        }).catch((error) => {
            console.error("Erro ao calcular o índice de favorabilidade:", error);
        });

    }, []);
    // Define the CSS for the custom segment labels


    return (
        <ReactSpeedometer
            width={700}
            minValue={-200}
            maxValue={200}
            value={indiceFavorabilidade}
            segments={5}
            customSegmentStops={[-200, -100, -30, 30, 100, 200]}
            customSegmentLabels={[
                {
                    text: "Muito Desfavorável",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#fff",
                    fontSize: segmentLabelFontSize,
                },
                {
                    text: "Desfavorável",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#fff",
                    fontSize: segmentLabelFontSize,
                },
                {
                    text: "Equilíbrio",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#555",
                    fontSize: segmentLabelFontSize,
                },
                {
                    text: "Favorável",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#555",
                    fontSize: segmentLabelFontSize,
                },
                {
                    text: "Muito Favorável",
                    position: CustomSegmentLabelPosition.Inside,
                    color: "#555",
                    fontSize: segmentLabelFontSize,
                }
            ]}
            segmentColors={["#FF0000", "#F6C600", "#FFFF00", "#A9D70B", "#00FF00"]}
            needleColor="black"
            valueFormat="d"
            currentValueText="Seu índice é ${value} %"
            valueTextFontSize="32px"
            height={400}
        />);

}

